export const modelFamiliesAndLinesCA = {
  'Q8 e-tron': ['Q8 e-tron', 'SQ8 Sportback e-tron'],
  'Q4 e-tron': ['Q4 e-tron', 'Q4 Sportback e-tron'],
  Q3: ['Q3'],
  Q5: ['Q5', 'SQ5', 'Q5 Sportback', 'SQ5 Sportback', 'Q5', 'Q5 Sportback', 'SQ5', 'SQ5 Sportback'],
  'Q6 e-tron': ['Q6 e-tron', 'SQ6 e-tron'],
  Q7: ['Q7', 'SQ7'],
  Q8: ['Q8', 'SQ8', 'RS Q8'],
  A3: ['A3 Sedan', 'S3 Sedan', 'RS 3'],
  A4: ['A4 Sedan', 'A4 allroad', 'S4'],
  A5: [
    'A5',
    'S5',
    'A5 Coupe',
    'S5 Coupe',
    'RS 5 Coupe',
    'A5 Sportback',
    'S5 Sportback',
    'RS 5 Sportback',
    'A5 Cabriolet',
    'S5 Cabriolet',
  ],

  A6: ['A6 Sedan', 'A6 allroad', 'S6', 'RS 6 Avant performance'],
  'A6 e-tron': ['A6 e-tron', 'S6 e-tron'],
  A7: ['A7', 'S7', 'RS 7 performance'],
  A8: ['A8', 'S8'],
  'e-tron GT': ['S e-tron GT', 'RS e-tron GT Performance'],
  'e-tron line': [
    'A6 e-tron',
    'S6 e-tron',
    'Q6 e-tron',
    'Q8 e-tron',
    'SQ6 e-tron',
    'SQ8 Sportback e-tron',
    'Q4 e-tron',
    'Q4 Sportback e-tron',
    'S e-tron GT',
    'RS e-tron GT Performance',
  ],
  'Audi Sport': [
    'RS 5 Coupe',
    'RS 5 Sportback',
    'RS 6 Avant performance',
    'RS 7 performance',
    'RS Q8',
    'RS e-tron GT Performance',
  ],
};

export const LIST_OF_MODEL_FAMILY = [
  'q3',
  'q5',
  'q7',
  'q8',
  'a3',
  'a5',
  'a6',
  'a8',
  'q4etron',
  'q6etron',
  'a6etron',
  'etrongt',
];

export const LIST_OF_VEHICLES = {
  '': {
    key: '',
    label: '',
    options: [],
  },
  q3: {
    key: 'q3',
    label: 'Q3 Family',
    options: ['Q3'],
  },
  q5: {
    key: 'q5',
    label: 'Q5 Family',
    options: ['Q5', 'Q5 Sportback', 'SQ5', 'SQ5 Sportback'],
  },
  q7: {
    key: 'q7',
    label: 'Q7 Family',
    options: ['Q7', 'SQ7'],
  },
  q8: {
    key: 'q8',
    label: 'Q8 Family',
    options: ['Q8', 'SQ8', 'RS Q8'],
  },
  a3: {
    key: 'a3',
    label: 'A3 Family',
    options: ['A3', 'S3', 'RS 3'],
  },
  a5: {
    key: 'a5',
    label: 'A5 Family',
    options: ['A5', 'S5'],
  },
  a6: {
    key: 'a6',
    label: 'A6 Family',
    options: ['A6'],
  },
  a8: {
    key: 'a8',
    label: 'A8 Family',
    options: ['A8', 'S8'],
  },
  q4etron: {
    key: 'q4etron',
    label: 'Q4 e-tron Family',
    options: ['Q4 e-tron', 'Q4 Sportback e-tron'],
  },
  q6etron: {
    key: 'q6etron',
    label: 'Q6 e-tron Family',
    options: ['Q6 e-tron', 'SQ6 e-tron', 'Q6 Sportback e-tron', 'SQ6 Sportback e-tron'],
  },
  a6etron: {
    key: 'a6etron',
    label: 'A6 e-tron Family',
    options: ['A6 e-tron', 'S6 e-tron'],
  },
  etrongt: {
    key: 'etrongt',
    label: 'e-tron GT Family',
    options: ['S e-tron GT', 'RS e-tron GT'],
  },
};

export const models = [
  {
    model: 'Undecided',
    modelOfInterest: 'AUA000',
    modelDeviation: 'AUA000',
  },
  {
    model: 'A6',
    modelOfInterest: 'AUA604',
    modelDeviation: 'AUA604',
  },
  {
    model: 'e-tron SUV',
    modelOfInterest: 'AUE001',
    modelDeviation: 'AUE001',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/genb/2021.png'],
  },
  {
    model: 'e-tron S',
    modelOfInterest: 'AUE001',
    modelDeviation: 'AUE001_AUE00S',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
  },
  {
    model: 'e-tron S Sportback',
    modelOfInterest: 'AUESB1',
    modelDeviation: 'AUESB1_AUESBS',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
  },
  {
    model: 'e-tron Sportback',
    modelOfInterest: 'AUESB1',
    modelDeviation: 'AUESB1',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/geac/2021.png'],
  },
  {
    model: 'A3 Sedan',
    modelOfInterest: 'AUA301',
    modelDeviation: 'AUA302',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
  },
  {
    model: 'A3 Sportback e-tron Phev',
    modelOfInterest: 'AUA301',
    modelDeviation: 'AUA304',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'A3 e-tron',
    modelOfInterest: 'AUA301',
    modelDeviation: 'AUA304',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'A3 Cabriolet',
    modelOfInterest: 'AUA301',
    modelDeviation: 'AUA303',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/8ve/2020.png'],
  },
  {
    model: 'S3 Sedan',
    modelOfInterest: 'AUS301',
    modelDeviation: 'AUS301',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
  },
  {
    model: 'RS 3',
    modelOfInterest: 'AUR301',
    modelDeviation: 'AUR301',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/8ysr/2022.png'],
  },
  {
    model: 'A4 Sedan',
    modelOfInterest: 'AUA401',
    modelDeviation: 'AUA400',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/8wc/2021.png'],
  },
  {
    model: 'S4',
    modelOfInterest: 'AUS401',
    modelDeviation: 'AUS401',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/8wcs/2021.png'],
  },
  {
    model: 'A5 Coupe',
    modelOfInterest: 'AUA501',
    modelDeviation: 'AUA501',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIhBPNonK7EsUS8zXy84tSgzMSezKjEpJ9V63QXONcHX33oyMTBUFDAwMDAC1TJFO635LP6DjSPkAVSYyZSBtaS0KCmfEagkgIkrMzcxPVU_qyA1nffTp0_8jNyJprqpFSW6eam5-exAJUI8ioXfzC65upzVit23Y-d7lcOt7wvKGXgYO4SmCRlUX9SI_tk6X3xFmmxE9T8GnjVfLOVPu1cvn_KdP27x6QP5N6s5FzHwzKiUsA8U9L5_Xfn2c1bOW8_FBSV4GHg-MWzltuJsf3us9qtd8IzcCheh3jgGngkhlx7GrHot8kHT8X2Y9uvIM5HHtzPw3I4O5XZdp-15Mo1lOmv85j9P77BIMfDkhN1LYr3yvbYza1vma1abyqMiy14z8LjGrX6iWcHTMO9u8fGH3UeMP5TMnsTAsytsBssx-3Ubdlsp5vxa8n91le5mCwaevRWKv1niLARuPjlxufPvSdn06xaCDDzfzVM4lsTMLNaJtf_6Z4frpaMXo9NxqWXk-1OXt2T-nHXnVbT1l3100p11cgkDj9jP8-q_9pay3f2sLsHLX-rJ4PiBhYEneNqL7mnfP_7gOii2Vu3b410ie50ZGHhkbfvmT3maqbtX6RPL-Ujb4G_MnSIMPApJiqe2_i1OOyCe7DRvlrVBIK_9EgZWYKQxiQMJFg0gwfMeSHC0MYBJIMHIDYpTDRCfsYeZgYG1AsjYxgACfHylRTkFiUWJuXrlmSklGYIaBkQCYVYfx0jXIADz-VCJfAIAAA?wid=1920',
    ],
  },
  {
    model: 'A5 Cabriolet',
    modelOfInterest: 'AUA501',
    modelDeviation: 'AUA502',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f5e/2021.png'],
  },
  {
    model: 'A5 Sport Cabriolet',
    modelOfInterest: 'AUA501',
    modelDeviation: 'AUA502',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'A5 Sportback',
    modelOfInterest: 'AUA501',
    modelDeviation: 'AUA503',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIhBPNonK7EsUS8zXy84tSgzMSezKjEpJ9V63QXONcHX33oyMTBUFDAwMDAC1TJFO635LP6DjSPkAVSYyZSBtaS0KCmfEagkgIkrMzcxPVU_qyA1nffTp0_8jNyJprqpFSW6eam5-exAJUI83Jr5TxabMr3vNq-1u7AoceUJjnXfGXgYO4SmCRlUX9SI_tk6X3xFmmxE9T8GnsDs33saMlZUb4_8--3TvmV-lv9_PGPgEXaqsOq6bn5787TG8zYWvdN8-X9_ZuDhWH-rWbZldnTW7MvpLEFntkc7COxj4Dmir1Ef_femnv7OeKsCO9N03UMTgbYZXr31Ldnc5-5px_UnzyX_vxk2fcFWBp4fEx6ufZnv2pO9d4NN18558wP-O19n4KlOfjqjap6xTnjsBbmWG4L55X4vjjLwcM0QqlI50Olulym8R9J1woteRXMOBp69FYq_WeIsBG4-OXG58-9J2fTrFoIMPN_NUziWxMws1om1__pnh-uloxej03GpbZU4KqNyaZO4_zfef-u89r9ON39owcDTWXzp2rpzdesueRlbbk1jto_bkb6ZgWeVb9dyNa4HvxdHx8578CO35mnS_BwGnkdz57otyo7Lknm8kjWuX87v4DlTYJiVcjknv2tfUuaulvlTdrLIVcVIkX4GVmCkMYkDCRYNIMHzHkhwtDGASSDByA2KUw0Qn7GHmYGBtQLI2MYAAnx8pUU5BYlFibl65ZkpJRmCGgZEAmFWH8dI1yAAu3nbAnwCAAA?wid=1920',
    ],
  },
  {
    model: 'S5 Coupe',
    modelOfInterest: 'AUS501',
    modelDeviation: 'AUS501',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f5ps4a/2023.png'],
  },
  {
    model: 'S5 Cabriolet',
    modelOfInterest: 'AUS501',
    modelDeviation: 'AUS502',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f5es/2021.png'],
  },
  {
    model: 'S5 Sportback',
    modelOfInterest: 'AUS501',
    modelDeviation: 'AUS503',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIhBPNonK7EsUS8zXy84tSgzMSezKjEpJ9V63QXONcHX33oyMTBUFDAwMDAC1TJFO635LP6DjSPkAVSYyZuBtaS0KCmfEagkgIkrMzcxPVU_qyA1nffTp0_8jNyJprqpFSW6eam5-exAJcI83Jr5TxabMr3vNq-1u7AoceUJjnXfGXgYO4SmCRlUX9SI_tk6X3xFmmxE9T8GHsGVbiu3XthUNKMgJnrDMXcu1kjjCgaeaOsOs7kTZT6efnJryYLXE8RXOCvmMfAkON0U8lx6JL5AYLVyzbTk6Ok_1BsZePjj7qi-m73hHefHs0LuHIxeLw7ur2bgaXq4KXfeDttaBvnz115cKDg3h2vhQgaeRn7j-WU_fl-czLf2Z_BehzwdvVPdDDz2VT_F2_YJPFtQaHecy9n-pfafe08ZeHhiTjLVs3gc90mKMjO3efEnrmVFJgNPdfLTGVXzjHXCYy_ItdwQzC_3e3GUged54lK-sg31KhO33fd0lbmeb3xsdhIDz94Kxd8scRYCN5-cuNz596Rs-nULQQaexLg78esu2teIeE4Qf7zIx0LywbxEXGo7iy9dW3eubt0lL2PLrWnM9nE70jcz8GTz7erw_vetYjdnzstjRqz3X9xsPMHAs8q3a7ka14Pfi6Nj5z34kVvzNGl-DgNPKZdz8rv2JWXuapk_ZSeLXFWMFOlnYAVGJZM4kGDRABI874EERxsDmAQSjNygmNYA8Rl7mBkYWCuAjG0MIMDHV1qUU5BYlJirV56ZUpIhqGFAJBBm9XGMdA0CAM884bWSAgAA?wid=1920',
    ],
  },
  {
    model: 'RS 5 Coupe',
    modelOfInterest: 'AUR501',
    modelDeviation: 'AUR501',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f5prxa/2023.png'],
  },
  {
    model: 'RS 5 Cabriolet',
    modelOfInterest: 'AUR501',
    modelDeviation: 'AUR502',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'RS 5 Sportback',
    modelOfInterest: 'AUR501',
    modelDeviation: 'AUR503',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIhBPNonK7EsUS8zXy84tSgzMSezKjEpJ9V63QXONcHX33oyMTBUFDAwMDAC1TJFO635LP6DjSPkAVSYyZSBtaS0KCmfEagkgIkrMzcxPVU_qyA1nffTp0_8jNyJprqpFSW6eam5-exAJUI83Jr5TxabMr3vNq-1u7AoceUJjnXfGXgYO4SmCRlUX9SI_tk6X3xFmmxE9T8Gng_nD2-883lSs4po9kVFqa_OXy3trBh4vp9fEBvi66IswRdyfm7X5P0Ho_2TGXiyk63X3czZYfdAc-9Zs7yndhs7LrAy8JQlRTakxdaca43S862Y1MGS_bLyNQNPym7-MI4NPXyiu4QuvmY5JMM4g2E2A0_0zK-3PxzW9TyUm_Lb7_BrtacKtjEMPNXJT2dUzTPWCY-9INdyQzC_3O_FUQaej7rP3r1ZtvEWR-YCkUqW9Z95IyQuMfDsrVD8zRJnIXDzyYnLnX9PyqZftxBk4Hlp-kaTLyT4pcDL0g3djIq2T9-tWI9LbaTv_fZ6n0NNaqvlznUt2eajK_NSh4Gns_jStXXn6tZd8jK23JrGbB-3I30zA88KsTybBW7K6qoV4Q8ME3hqFyyKe8LAo73O6sc25sCvVzdqXJXd6lvYnzgzgYGnlMs5-V37kjJ3tcyfspNFripGivQzsAIjjUkcSLBoAAme90CCo40BTAIJRm5QnGqA-Iw9zAwMrBVAxjYGEODjKy3KKUgsSszVK89MKckQ1DAgEgiz-jhGugYBAOKVyNp8AgAA?wid=1440',
    ],
  },
  {
    model: 'A6 Sedan',
    modelOfInterest: 'AUA601',
    modelDeviation: 'AUA600',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4a2/2021.png'],
  },
  {
    model: 'S6',
    modelOfInterest: 'AUS601',
    modelDeviation: 'AUS601',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4a2s/2021.png'],
  },
  {
    model: 'RS 6 Avant performance',
    modelOfInterest: 'AUR601',
    modelDeviation: 'AUR601',
    webCE: 'AUUS_IB_DC_19_PRERESV_HR',
    mobileCE: 'AUUS_IB_DC_19_PRERESV_HR',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4a5r/2021.png'],
  },
  {
    model: 'A7',
    modelOfInterest: 'AUA701',
    modelDeviation: 'AUA700',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/live/50710/hb/4ka02y-2/2020/14+a2a2/aaue0a/aer0p0/ahv1d0/ata1x1/awv6k8/bav1lp/bbo6fa/dei3fb/eph7x2/fsp5l0/gra8t2/hes5j2/hsw8it/ksuka2/kzv6w9/lia8g1/rad44q/sbr8sp/sctql1/sfs2k1/spu7y0/ssh4kc/swr8x0/szu0na/tyz2z7/zie4zb.png?wid=900',
    ],
  },
  {
    model: 'A7 Sportback',
    modelOfInterest: null,
    modelDeviation: null,
    webCE: null,
    mobileCE: null,
    showInHR: false,
    showInLeadForms: false,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4ka/2021.png'],
  },
  {
    model: 'RS 7 performance',
    modelOfInterest: 'AUR701',
    modelDeviation: 'AUR701',
    webCE: 'AUUS_IB_DC_19_PRERESV_HR',
    mobileCE: 'AUUS_IB_DC_19_PRERESV_HR',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIhBPNonK7EsUS8zXy84tSgzMSezKjEpJ9V63QXONcHX33oyMTBUFDAwMDAC1TJFO635LP6DjSPkAVSYyZSBtaS0KCmfEagkgIkrMzcxPVU_qyA1nffTp0_8jNyJ5rqpFSW6eam5-exAJUI8i0OmMa76puevunR6yQxbsUMzop_ZMfCsa-dcftA4IDHUVjvmANPGGWFcksEMPHrSO7wuatk945Zn-Ga3-fm1FVq-Ngw8qq_9ZttmS7YvYPy_52DS2ln1RV31DDyh_NHCCyd9kbH2cDBaJ9N0rzj14iygua79cZLBBcopl19eXnlEM5uZ89ZKoAkMNxlSVi_IOmXToPHw7LbkRuY_mxl4_gtJT9R-93-KcpNcM8O_K_GRcR_uMPDI_DXubX56jrHu6FX5VMWTn17n3l_IwDNhAnfxuoQ33a_6G5L_pWqeeXPZeicDT8vZU9dZ3ITS5vaZfuk809gSeDISaELyshtBvTXOqY5347WvR0QxT8169gNo25yjiyQYlnxZd_t81p9jx6pn__jGxcDDK-cw6fmsXmmT-iTZt3qJ3_Tizpxi4NlbofibJc5C4OaTE5c7_56UTb9uIcjAU1u-gfPMYp5dvj8f2k56wP3SdNmvCww8OnaBAn8kDmuJaVwP_Gp1p4Hz_JlJDDxnGgKf7WmW0WbmNxUyvzux_G_IThsGVmCkMd4FEiwKQIIXxOUoYQCToOj8BSI0QHzGNmYGBtYKIGMbAwjw8ZUW5RQkFiXm6pVnppRkCGoYEAmEWX0cI12DAAru9iR8AgAA?wid=1440',
    ],
  },
  {
    model: 'S7',
    modelOfInterest: 'AUS701',
    modelDeviation: 'AUS701',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/live/50710/hb/4kasfa-1/2020/14+t9t9/aaue0a/aer0p0/ahv1d0/ata1x1/awv6k8/bav1lw/bbo6fc/dei3fb/eph9x0/fsp5l0/gra8t2/hes5j2/hsw8it/ksuka6/kzv6w9/lia8g5/rad42f/sbr8sq/sctql1/sfs2k3/spu7y0/ssh4kc/swr8x1/szu0na/tyz2z8/zie4zb.png?wid=900',
    ],
  },
  {
    model: 'S7 Sportback',
    modelOfInterest: null,
    modelDeviation: null,
    webCE: null,
    mobileCE: null,
    showInHR: false,
    showInLeadForms: false,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4kas/2021.png'],
  },
  {
    model: 'A8',
    modelOfInterest: 'AUA801',
    modelDeviation: 'AUA800',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: [
      'https://mediaservice.audi.com/media/live/50710/hb/4n85da-0/2020/14%2Bl5l5/aaue0a/aer0p0/ahv1d0/awv6k8/bav1lp/bbo6fb/dei3fu/eph7x2/gmot9i/gra8t2/hsw8it/kark8l/ksuka2/kzv6w3/lia8g1/radcw4/sbr8sp/sctql1/sfs2k1/spu7y0/ssh4kc/swr8x0/tyz2z7/zie4zb.png?wid=900',
    ],
  },
  {
    model: 'A8',
    modelOfInterest: 'AUA801',
    modelDeviation: 'AUA803',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4n8/2021.png'],
  },
  {
    model: 'A8 W12',
    modelOfInterest: 'AUA801',
    modelDeviation: 'AUA802',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'S8',
    modelOfInterest: 'AUS801',
    modelDeviation: 'AUS801',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4nl5s/2022.png'],
  },
  {
    model: 'A4 allroad',
    modelOfInterest: 'AUAQ01',
    modelDeviation: 'AUAQ01',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/8wj/2021.png'],
  },
  {
    model: 'A6 allroad',
    modelOfInterest: 'AUAQ02',
    modelDeviation: 'AUAQ02',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4ah/2021.png'],
  },
  {
    model: 'Q3',
    modelOfInterest: 'AUQ310',
    modelDeviation: 'AUQ310',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f3b/2021.png'],
  },
  {
    model: 'Q4 e-tron',
    modelOfInterest: 'AUQ401',
    modelDeviation: 'AUQ401',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f4b/2022.png'],
  },
  {
    model: 'Q4 Sportback e-tron',
    modelOfInterest: 'AUQ401',
    modelDeviation: 'AUQ402',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f4n/2022.png'],
  },
  {
    model: 'Q5',
    modelOfInterest: 'AUQ501',
    modelDeviation: 'AUQ501',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fyg/2021.png'],
  },
  {
    model: 'Q5 hybrid',
    modelOfInterest: 'AUQ501',
    modelDeviation: 'AUQ502',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'Q5 Sportback',
    modelOfInterest: 'AUQ501',
    modelDeviation: 'AUQ504',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fyt/2021.png'],
  },
  {
    model: 'SQ5',
    modelOfInterest: 'AUSQ51',
    modelDeviation: 'AUSQ51',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fygs/2021.png'],
  },
  {
    model: 'SQ5 Sportback',
    modelOfInterest: 'AUSQ51',
    modelDeviation: 'AUSQ52',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fyts/2021.png'],
  },
  {
    model: 'Q5 TFSI e Phev',
    modelOfInterest: 'AUQ501',
    modelDeviation: 'AUQ503',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fyb52y/2020.png'],
  },
  {
    model: 'Q7',
    modelOfInterest: 'AUQ701',
    modelDeviation: 'AUQ701',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4mg/2021.png'],
  },
  {
    model: 'SQ7',
    modelOfInterest: 'AUSQ71',
    modelDeviation: 'AUSQ71',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4mgs/2021.png'],
  },
  {
    model: 'Q8',
    modelOfInterest: 'AUQ801',
    modelDeviation: 'AUQ801',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4mn5x/2021.png'],
  },
  {
    model: 'SQ8',
    modelOfInterest: 'AUSQ81',
    modelDeviation: 'AUSQ81',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4mn5w/2021.png'],
  },
  {
    model: 'RS Q8',
    modelOfInterest: 'AURQ81',
    modelDeviation: 'AURQ81',
    webCE: 'AUUS_IB_DC_19_PRERESV_HR',
    mobileCE: 'AUUS_IB_DC_19_PRERESV_HR',
    showInHR: true,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4mnr/2021.png'],
  },
  {
    model: 'TT Coupe',
    modelOfInterest: 'AUTT01',
    modelDeviation: 'AUTT01',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fvp5ey/2021.png'],
  },
  {
    model: 'TT Roadster',
    modelOfInterest: 'AUTT01',
    modelDeviation: 'AUTT02',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fvr5ey/2021.png'],
  },
  {
    model: 'TTS Coupe',
    modelOfInterest: 'AUSTT1',
    modelDeviation: 'AUSTT0',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fvp51y/2021.png'],
  },
  {
    model: 'TTS Roadster',
    modelOfInterest: 'AUSTT1',
    modelDeviation: 'AUSTT2',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'TT RS Coupe',
    modelOfInterest: 'AUTT01',
    modelDeviation: 'AUTT03',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/fvprsy/2021.png'],
  },
  {
    model: 'R8 Coupe',
    modelOfInterest: 'AUR801',
    modelDeviation: 'AUR801',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4spr/2021.png'],
  },
  {
    model: 'R8 Spyder',
    modelOfInterest: 'AUR801',
    modelDeviation: 'AUR802',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: true,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/4srr/2021.png'],
  },
  {
    model: 'Family',
    modelOfInterest: 'AUNULL',
    modelDeviation: 'AUNULL',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'e-tron Brand',
    modelOfInterest: 'AUE101',
    modelDeviation: 'AUE101',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'e-tron Reservation',
    modelOfInterest: 'AUE201',
    modelDeviation: 'AUE201',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'e-tron SUV S',
    modelOfInterest: 'AUES01',
    modelDeviation: 'AUES01',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'e-tron sportback S',
    modelOfInterest: 'AUESS1',
    modelDeviation: 'AUESS1',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'e-tron sportback Reservation',
    modelOfInterest: 'AUERES',
    modelDeviation: 'AUESB1',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'S e-tron GT',
    modelOfInterest: 'AUEGT1',
    modelDeviation: 'AUEGTS',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f83rj7/2022.png'],
  },
  {
    model: 'RS e-tron GT Performance',
    modelOfInterest: 'AUEGT1',
    modelDeviation: 'AUEGTR',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    year: 2024,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/f83rh7/2022.png'],
  },
  {
    model: 'e-tron PB18',
    modelOfInterest: 'AUEP18',
    modelDeviation: 'AUEP18',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'DriveProgress',
    modelOfInterest: 'AUNULL',
    modelDeviation: 'AUPROG',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: false,
    showInLeadForms: false,
  },
  {
    model: 'Q8 e-tron',
    modelOfInterest: 'AUE801',
    modelDeviation: 'AUE801',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    year: 2024,
  },
  {
    model: 'Q8 Sportback e-tron',
    modelOfInterest: 'AUE801',
    modelDeviation: 'AUE802',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    images: ['https://mediaservice.audi.com/media/live/50710/fly1400x601n1/get/2024.png'],
    year: 2024,
  },
  {
    model: 'SQ8 e-tron',
    modelOfInterest: 'AUE801',
    modelDeviation: 'AUE803',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIiBOTrayfuvpGh6-m1zJgaGigIGBgZGoDhTtNOaz-I_2DhCHsCElzEwF-SlMwJZKUycmbmJ6an6QD4_I3taTmV-aUkxO0grz8NU5nV5iQlv5HsWrPO5srjRUiT5CAMrUBfjKiDBzAEk-MKBBKcqA5gEmbcCRNiB-EyWzAwMrBVARiQDCAhqGBAJhNldXEMcPX2CAahBJjrZAAAA',
    ],
    year: 2024,
  },
  {
    model: 'SQ8 Sportback e-tron',
    modelOfInterest: 'AUE801',
    modelDeviation: 'AUE804',
    webCE: 'AUUS_IB_DC_00_HNDR_RG',
    mobileCE: 'AUUS_IB_DC_00_HNDR_RG',
    showInHR: true,
    showInLeadForms: false,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAAAFvzloG1tIiBOTrayfuvpGh6-m1zJgaGigIGBgZGoDhTtNOaz-I_2DhCHsCElzEwF-SlMwJZKUycmbmJ6an6QD4_I3taTmV-aUkxO0grj9fKKyIf5DsdZqvsleLwzxEprPrmycAK1MW4CkgwcwAJvnAgwanKACZB5q0AEXYgPpMlMwMDawWQEckAAoIaBkQCYXYX1xBHT59gAEsrGTzZAAAA',
    ],
    year: 2024,
  },

  {
    model: 'Q6 e-tron',
    modelOfInterest: 'AUQ601',
    modelDeviation: 'AUQ601',
    year: 2025,
    showInHR: true,
  },
  {
    model: 'SQ6 e-tron',
    modelOfInterest: 'ASQ601',
    modelDeviation: 'ASQ601',
    year: 2025,
    showInHR: true,
  },
  {
    model: 'A6 e-tron',
    modelOfInterest: 'AUA601',
    modelDeviation: 'AUA610',
    year: 2025,
    showInHR: true,
  },
  {
    model: 'S6 Sportback e-tron',
    modelOfInterest: 'AUS601',
    modelDeviation: 'AUS611',
    year: 2025,
    showInHR: true,
  },
  {
    model: 'A6 Sportback e-tron',
    modelOfInterest: 'AUA601',
    modelDeviation: 'AUA611',
    year: 2025,
    showInHR: true,
  },
  {
    model: 'A5',
    modelOfInterest: 'AUA510',
    modelDeviation: 'AUA503',
    year: 2025,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAA_y2VvY7lNBSA78zAAs0i_oR4gQFpJY6dn5ukGKHdbZCgWAlEs8Xo2PHftZM4dpI7kweg4Fn2Qeho6Gh4ga1oaJA4F9H4yzm2c_6TN28P767pcPP69Yvv_vniM2P-aK4Ph4d4OByuSH_9-sWbvz7_-8n7P_75v_qJPdzE0VzRgf76AzegUUDyh4f3SHN496L_mZarX2h58jst78TDf-tl5-1leXWRr369odOfHg7XX17uHZ4-XVOImHD4uldiNR99VXDNRdtyWUkltdC1kNgcVcFkKWVbopJVw_oCP6b3_IYTwlhMjC8pgl4LFI8MClbUwKtn9VqvUB-f6TMgYmVKwqoYAorpaBkh8UiS6ms3ExKLpDRDtfWAduM9SU5U60IIZiMpRpNrwKyOD55gFJIyD2a4INcnSXhknqQF-QMHXDN2GvC8tacSBFruNWE58ZGw8eBBkC8aQfTxRC4JjWwlyfjxsQARhCB3xYJsG0BaLCwnpPlEmCgbLciIbikJwq1HgnRbQejdmZTLgzkz6FFxgYRUZpKUK7WBXpPZCpRUo-tA9ecGAyhn60ESwkbvVG6dWwEq2u6BgcquOTeEvKoWNPaMvNZqPVIKtD1vmhBy52rQU68jB51jHUi5Z00xGDW2ZgXjLXs8ETZ2IgzTUikwCVuyZ9KyyQJMjob3YNEYW4FVCWtOoOwysA7ZSJIbjuMJrMcOZ7D53KoHsGvvKT77KAqy58ZeS0bIay3BpVyFBjwqRgXwmDwF5sXGhgJ8nytbgw87e6zAD3FOHSFXVH4_DUZcsNU73UsD34-EzJHuZawlncyrv0j7UnIJAWXtG4LXooIg4zwXEHoxUh1C34-nCww1KmFS5G5QGFiAYHd0LQSHreGEISy0R_5uF4imRIJsjoQpNZTdkLDYZ8KGVPCQVUdNG3IuJFlfh8YKGDAfVQlDn_XQwqAGdBwGjV3uYPBKUeyDX1uKaJjQUbdSNXpewYhbsxoYx1HvHCIOhsYiYu46AVEuXRcgKl_HAqJeu9ZDNKjJ3ejGrk0QfehaQ5i6VkLMrusczGbQM4N5RSQk7CvuCGt3QkhyUn0JqfeNJyjXlokQNipjUokbBhnFUVaElWWELFJL85Bl0jRqWS5z4JB7W6kGssLZEXQufE3YC017xneRlE6MPBJUGWjP2QpLws6CgOzxRCnIIbXzCfJo20eS4tp0FnKyR-rrnG3lJSGV9JHJy2KomnmbaGQhn1P7QBbOe0dflMWo46mHxW8VNcMSTSc4IQiq-5J0rVvCuZR0clPzVsJyDnwzhJVTfMtj5CoS9mJvYBOeU3Y3LfipgG3yhuxtU545wrZs3b7BGUO3ICEp6rNzxkZdkCszwy5ScUbY9cCWHnanql3A7rdSNLDnzNIO-2q7gX2jxs2laRzUuNx9O61Z3b-0OIgp9fcvccQeb8-uX-wd7wp2a5UzdrnjVcVuMUSLd0ta1a3EgQb27odl7d10__y-uGeMDoz0v1jcNOa7V1N2l6fvL9dv86JUcqPB0QR1x9knN89_evUv90pzm5sGAAA?wid=1400',
    ],
    showInHR: true,
  },
  {
    model: 'S5',
    modelOfInterest: 'AUS510',
    modelDeviation: 'AUS503',
    year: 2025,
    showInHR: true,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAA_1vzloG1tIiBOTrayfuvpGh6-m1zJgaGigIGBgZGoDhTtNOaz-I_2DhCHsCEtzEwF-SlMwJZKUycmbmJ6an6QD4_I3taTmV-aUkxO0grD2elN8_mWa-eC0qFHjt26WXBl9yflgysQF2Mj4AE8xIgwacFJDjlGcAkyLyjIKIBxGeyZWZgYK0AMiIZQICPr7QopyCxKDFXLyU1qTRdUMOASCDM7uIa4ujpEwwAWRCNAukAAAA',
    ],
  },
  {
    model: 'Q5',
    modelOfInterest: 'AUQ510',
    modelDeviation: 'AUQ510',
    year: 2025,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAA_y2Uza7dNBCAT3vVFjZFgBDiBa4qVWLi_JwkiyvUih0gVQKx6eJqnNiOj-3Ex3acc7LiUXiAPgGvwoYXYMWGDRJzpEqRvsyMx2PPjz_8fXi2hsPd-_dvf_jvm6-U-rN9ejhc_OFweEL6p-_ffvjn63-ff_LLXx_Vz18d7vysntCC8emn2qESQPJnhxekOdwdDi9-Oxye_X6zH16-XIP1GNB9Owq-qs9fVbwbR1EzFFxI7Fhfjceqaeuad3VRViOKamgEsi9ojz9wQZjVMMiwzKmqRxFNWryYM7tYUCtHvBabT_RBWZQNsPq1bWwDzfG13AARa1URVlEgIA_ME8TY6EAIhS8AlavnCXDKbOwANa9XR7Aqk82qs2CA3qvYAEZxvBiCEki26JS7ITangXAtDEkJ2YUc1oi9BNxyd6qA48SMJKQTmwmZWQOcL0eJwEd_mhhwyzkdkCcssoNhwpKUwxTOJ8IyDM0RBo86VQSu15s06FwSRr2RMl3UVgBljnFDCFVkMApdyRVGSYFqEIOYdQ9i3Fq0IPTUuIFgM-0p9HruOAg_9ZcCRNTt1hLi2guQOBZ0TinWI11aTluWBBt73YBcRukZyD1KOrwSc68KUGYqrpKQixPBLWlgoAJ2FEiFlIcSVPSKjTCJgA0jUAYLmLQ7zidCrOYIk8EezzDFrdNXmNbR0I2mKy8pkJ7j2gygQ6xtCwZFQdk1GEw9geG5cCUYi4LKYexeXGswzp9DT4j1WIFZnOJkW3Kzn8AEx3ZyCJEhIWIz0Mq4GiS_PVVsAItDYxqCkbwGO_jzmTDymVJux3E-3aDkWhIWEUkSaAsLdtqRUm41dooRnE1ko_PmG3hbIWFojzdYMZFyCS3l0wYs9zMhI5XYRtHnSPB2I1uM5dCCXV07cXAYj6ICN0bpOnDCoWbgJPaxB2eEoEw4s3b7EdyCmhqTqjGyGmbM7arAo1M0AR5j3w_gh9T3AbwwjS_By7XvHHiFMjHweu67CN7YviM_s_QdOUTd9xrOyslzAecVkRBwrDtPWPsTQhgWQSkPo2kNgdquvRBspjIGERj1S0R-HGrCWkSEyEOXrxCHIKl-cUhnmuU4TrU4QhR41i1EGUsqR5R7KRlEZXpPSs1ndiGI6uagp5rqF_VeWA7R4InuHuepu9Kefm37CWKYjtTCMU55uyFU1CgxJXWiQHmR1OxxC92lg2RybVpIXvWcESynSqcgG0m2sFUDQsrinCtIm2VZEVZGV0lXz4Qn7OXeQuaGUfmz5OxUQl6Mogh5iWcahJxyv2fY0PYJCUFQZ3181LaIrSApxlqdYeeh3BB26Yo0wq5FvXPYTa54C3uMRdhhX6feFd_RC6npyXRiTg9vghHz409rFKt7_F7MjmblftNjmh5YXxb3k9BqSg-srot7tH7ChxRWcT-gowl9-Dmto14e3zyWj0VBC2Z675Ne5vjwbon69vfjzf0-JiGCnhXOyooHVnx59-bXd_8DlH5VXlsGAAA?wid=1400',
    ],
    showInHR: true,
  },
  {
    model: 'SQ5',
    modelOfInterest: 'AUSQ10',
    modelDeviation: 'AUSQ10',
    year: 2025,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAA_1vzloG1tIiBOTrayfuvpGh6-m1zJgaGigIGBgZGoDhTtNOaz-I_2DhCHsCEtzEwF-SlMwJZKUycmbmJ6an6QD4_I3taTmV-aUkxO0grT9I5ty2Htk06mv7Fy-tZh9vnqezWPxhYgboYPYAE0zMgwbcLSHB6M4BJkHlzQYQdiM9kxczAwFoBZEQygAAfX2lRTkFiUWKuXkpqUmm6oIYBkUCY3cU1xNHTJxgAHo1gdekAAAA',
    ],
  },
  {
    model: 'Q5 Sportback',
    modelOfInterest: 'AUQ510',
    modelDeviation: 'AUQ540',
    year: 2025,
    showInHR: true,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAA_y2Uza7dNBCAT3vVAhIqfwLEC1whVWLs_GdxhVqxA6RKIDZdXI0T2_FxnDh24pyTJ2LRN2LDC7BiwwaJOahHR_oy9oxnxjPjd3-dnm3hdPf27esf__3mS63_qJ-eThd_Op2e0PrTt6_f_f31P88__PXP98vPvzrd-Uk_IYX-6UfGoZZA8ienD2jldHc6fUr4-PT_78WLLYweA7rveik2_dm3os_7SiCXouMiR1YzVrdKKN5mdSebquRNpso8-_x0evZ7hxNM0s2Mg96mWF7Z7q_0h4xlJfDiZWUqA2X1Ul8AEQudEzbJEFAE7gmyz5kgBOYZoHZF6gGHxPsG0Ihic4RRJ9ob9SI5oPc6loBRVhdL0BJpLzrtbojluSNcmSVpRX4hgy1iowD31JxzEDhkUhHWM58IiY8dCDFXagfR-_PAQIxCUIBiRZYcdANmAyeE5UyYu66soPNo1pwgzHaTOpMKQm92WlwvemfQo8ycIIQ8cuilydUGvSJHNchOTqYF2e81jiDNUDpLGNNaEral6UH6ob0wkNHUOxnEuLUSFPZMISi5VZS0GvakOKgxtqYBNffKk3RERcFrObWagbYDuypCYucBtJvXoQUdsKHgdVhTl4GOXvMeBhmw5AS6QQaDcdW0EGI-RRgstkhS3BtzhWHrLWU0XEVGjswUt7IHE2Ix1mBRMqsIwTYBrEjMZWBHlFQOOx7smoN1fgktIRY9SbPTglTmVB5nsMHxg6QQORIilh1pxs1iAfZYc97BiF1pS4JVooCx88tC6MVEVz72_XS-QastI8wykiRxZCOMw4F05aPBRnOCG1fao3jTDaLOkdDV1Q2jpC4Y59CYCsZATXQlJEx0ZpRtigQ_3vzFmHU1jJurBwEOYyVzcH1UEwMnHRoOTmEbW3BWSroJZ7fmKMDNaKgxqRp9iTBhqjcNHp2mCfAY27YD361tewEvbekz8GprGwdeo1o5eDO1TQRvx7YhOzu3DRlE07YGFu3UwmHZEBcGAfuSEgu4tWdCN9OwQehtbQnUdhR8kGOiMgYZuG4goqi6grCxiBBFaJKH2AVF9YvduowlxH4oZAVR4mJIU8WMDovqyKgVo7atryEaMeWOIPObgRkKql80B6NRixbPlHuchuZKZ_qtbgeIYagMacahsKQSQ34lg3XVZ3KUZkXNHvfQXBpYbSpsDavXreCEUeQlrEGVivbCnncIa5JLymHdR54GwsYplfXqufSEIztqSMJyusikBD9nkGaryUOa40KDkNbUHhJ2HNsVCUFSpd8_anvEWpIUY6EXOETIdoRDObb2cBhZHAIOm3JRwxEjCwcc29A69r2ckgnz5OS0PrwKVk6PP29Rbu7xBzk5mpX73fTr8EAvLLsfpNHD-sCLgt3j6Ad8WMMm7zt0NKEPv6xbb-bHV4_ZI2OkMNHrvpp5ig9v5mhuXz_dzO_jKmUwk8ZJj_KBsy_uXv325j9D80pvSQYAAA?wid=1200',
    ],
  },
  {
    model: 'SQ5 Sportback',
    modelOfInterest: 'AUSQ10',
    modelDeviation: 'AUSQSB',
    year: 2025,
    showInHR: true,
    images: [
      'https://mediaservice.audi.com/media/fast/H4sIAAAAAAAA_y2Uy67kNBBAe2Y0A0hoeAkQP3CFNBJl59FJFldoEDtAQgKxmcVVObEdt-3EsRPndr6IxfwRG36AFRs2SFSjabV0Ui-XXVX2279Oz7d4evbmzXc__PvV51r_0Tw9nR7D6XR6Qvqnb757-_eX_7x4_9c_36lffHF6Fib9hByGpx8Yj1oCyR-d3iPN6dnp9DHhw9P_v5cvt-gCRvTfDFJs-pOveVXXsq0YVkUjWVniWQmmGlZiTR8d64U4nwtRfno6Pf-9xwkm6WfGQW8T4pXt4Up_KFhRA69eFUMxQH1-pXZAxEqXhE0yBBSRB4IcSiYIkQUGqH01jYBj5kMLaES1eYLTmWxOL5IDhqBTDZjk-dEStESyJa_9Dam-9IQrsyStyB8pYEvYKcA9t5cSBI7cKsJ64RMhc2dBiPmsEMQQLiMD4YSgDYoVWfbQj1iMnBCXC2Hu-_oMfUCzlgRhtpvUm1wRBrOTcn3UO4MBZeEjIZaJwyBNqTYYFCWqQPZyMh3IYW_QgTRj7RXBZVpTmm1pBcgwdo8MZDLN3hDS1klQODDap5LbmQ6txj0rgkudaUHNgwoc1JEUbV7LqdMMtB3Z1RIyuxD8vPbUqIgtJdJxzX0BOgXNBxhlxJoTqIIMRuPP04WQyinBaLHDBca0t-YK4zZYOtF4FQUlMlPa6gFMTJVrwKJkVF2L0bYRrMjMF2AdSmqHdQe7lmB9WGJHSNVAytlrQS5zrg-Ki54fJMXEkZCw7skzbRYrsMda8h4c9rWtCVaJClwfloUwiIlK7oZhutyg1VYQZplIkuiYAzceSCV3BlvNCd6tZKP95htEUyKhb843OElT4ObYUD1dxOJYCBkzrZlklxMhuFu-lIq-Abf5ZhTgMZ1lCX5IyjfgpUfDwSvsUgfeSkmV8HZrjwr8jIYGk7ox8AomzM2mIaDXdAMCpq7rIfRr1zkI0tahgKC2rvUQNKqVQzBT1yYI1nUtxdm5aykgma4zsGivFgbLhkiIOFTsIGzdBSH2M102iINtLOE2dorgMrUxyshpXhKKc18RNpYQkohtDpD6qKh_qV8XV0MaxkqeIUlcDHmqVNiGcBSKQ9K2CyQZMXGKM7K8BZixov4lczDXQ7J4obOnaWyvtGbYmm6EFMezIc80VpZcUixvtnXVF0qUZ0XDnvbYPraw2lxRvjXoTnCCE2UNa1S1Ilvcyx5hzXLJJay741kTNk5HWa-By0A4iqOBLCynQmYl-KWAPFtNGfKcFo6Q19wdEnZ03YqEKKnT7x61PSE9iYRU6QUOEYsd4VCerQMcRlaHgMPmUjRwpMTiAcc2dp59K6ds4jx5Oa33r6OV08NPW5Kbf_heTp7uyt1uhnW8513B7kZp9Lje86pid-jCiPdr3ORdj55u6P0v6zaY-eH1Q_HAGDlM9LqvZp7S_c9zMrevH2_hd2mVMppJ46SdvOfss2evf_v5P3iGWSNJBgAA?wid=1200',
    ],
  },
  {
    model: 'S6 e-tron',
    modelOfInterest: 'AUS601',
    modelDeviation: 'AUS612',
    year: 2024,
  },
  {
    model: 'Q6 Sportback e-tron',
    modelOfInterest: 'AUQ601',
    modelDeviation: 'AUQ6SB',
    year: 2024,
  },
  {
    model: 'SQ6 Sportback e-tron',
    modelOfInterest: 'ASQ601',
    modelDeviation: 'ASQ6SB',
    year: 2024,
  },
];
